import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgIf } from '@angular/common';
import { GalapagosproComponent } from './templates/galapagospro/galapagospro.component';
import { GalavailComponent } from './templates/galavail/galavail.component';
import { FourworldstravelsComponent } from './templates/fourworldstravels/fourworldstravels.component';
import { FusiontravelecuadorComponent } from './templates/fusiontravelecuador/fusiontravelecuador.component';
import { GalapagosdeComponent } from './templates/galapagosde/galapagosde.component';
import { GloballandtourComponent } from './templates/globallandtour/globallandtour.component';
import { GalapagosinsidersComponent } from './templates/galapagosinsiders/galapagosinsiders.component';
import { HakuadventureComponent } from './templates/hakuadventure/hakuadventure.component';
import { AdventurejourneysComponent } from './templates/adventurejourneys/adventurejourneys.component';
import { MytriptoecuadorComponent } from './templates/mytriptoecuador/mytriptoecuador.component';
import { CamiadventuresComponent } from './templates/camiadventures/camiadventures.component';
import { EcuatravelingComponent } from './templates/ecuatraveling/ecuatraveling.component';
import { QuitobiketoursComponent } from './templates/quitobiketours/quitobiketours.component';
import { GalatrailsComponent } from './templates/galatrails/galatrails.component';
import { QuitotourbusComponent } from './templates/quitotourbus/quitotourbus.component';
import { QuichuanativetravelComponent } from './templates/quichuanativetravel/quichuanativetravel.component';
import { NaturegalapagosComponent } from './templates/naturegalapagos/naturegalapagos.component';
import { ImagineecuadorComponent } from './templates/imagineecuador/imagineecuador.component';
import { GalapagoslastminutesComponent } from './templates/galapagoslastminutes/galapagoslastminutes.component';
import { SurtrekComponent } from './templates/surtrek/surtrek.component';
import { EquatorexpeditionsComponent } from './templates/equatorexpeditions/equatorexpeditions.component';
import { EcuadorfamilytoursComponent } from './templates/ecuadorfamilytours/ecuadorfamilytours.component';
import { CarpedmComponent } from './templates/carpedm/carpedm.component';
import { GulliverexpeditionsComponent } from './templates/gulliverexpeditions/gulliverexpeditions.component';
import { AntarcticbookingcenterComponent } from './templates/antarcticbookingcenter/antarcticbookingcenter.component';
import { TakiritravelComponent } from './templates/takiritravel/takiritravel.component';
import { ColumbustravelecuadorComponent } from './templates/columbustravelecuador/columbustravelecuador.component';
import { GalapagosluxurycruisesComponent } from './templates/galapagosluxurycruises/galapagosluxurycruises.component';
import { DiscoverygalapagosComponent } from './templates/discoverygalapagos/discoverygalapagos.component';
import { EcuadortierradefuegoComponent } from './templates/ecuadortierradefuego/ecuadortierradefuego.component';
import { HandmadetravelComponent } from './templates/handmadetravel/handmadetravel.component';
import { VolcanicparadisegalapagosComponent } from './templates/volcanicparadisegalapagos/volcanicparadisegalapagos.component';
import { LatamretreatsComponent } from './templates/latamretreats/latamretreats.component';
import { GalapagosdreamsComponent } from './templates/galapagosdreams/galapagosdreams.component';
import { MidlandtravelComponent } from './templates/midlandtravel/midlandtravel.component';
import { LinkexperiencesComponent } from './templates/linkexperiences/linkexperiences.component';
import { ScubaiguanaComponent } from './templates/scubaiguana/scubaiguana.component';
import { GalaappComponent } from './templates/galaapp/galaapp.component';
import { GalapagosedenComponent } from './templates/galapagoseden/galapagoseden.component';
import { GalapagosdestinytoursComponent } from './templates/galapagosdestinytours/galapagosdestinytours.component';
import { LuxuryprivatejourneysComponent } from './templates/luxuryprivatejourneys/luxuryprivatejourneys.component';
import { PapayatoursComponent } from './templates/papayatours/papayatours.component';
import { RebeccaadventuretravelComponent } from './templates/rebeccaadventuretravel/rebeccaadventuretravel.component';
import { GettravelgalapagosComponent } from './templates/gettravelgalapagos/gettravelgalapagos.component';

@Component({
    selector: 'app-custom-header',
    templateUrl: './custom-header.component.html',
    styleUrls: ['./custom-header.component.scss'],
    imports: [NgIf, GalapagosproComponent, GalavailComponent, FourworldstravelsComponent, FusiontravelecuadorComponent, GalapagosdeComponent, GloballandtourComponent, GalapagosinsidersComponent, HakuadventureComponent, AdventurejourneysComponent, MytriptoecuadorComponent, CamiadventuresComponent, EcuatravelingComponent, QuitobiketoursComponent, GalatrailsComponent, QuitotourbusComponent, QuichuanativetravelComponent, NaturegalapagosComponent, ImagineecuadorComponent, GalapagoslastminutesComponent, SurtrekComponent, EquatorexpeditionsComponent, EcuadorfamilytoursComponent, CarpedmComponent, GulliverexpeditionsComponent, AntarcticbookingcenterComponent, TakiritravelComponent, ColumbustravelecuadorComponent, GalapagosluxurycruisesComponent, DiscoverygalapagosComponent, EcuadortierradefuegoComponent, HandmadetravelComponent, VolcanicparadisegalapagosComponent, LatamretreatsComponent, GalapagosdreamsComponent, MidlandtravelComponent, LinkexperiencesComponent, ScubaiguanaComponent, GalaappComponent, GalapagosedenComponent, GalapagosdestinytoursComponent, LuxuryprivatejourneysComponent, PapayatoursComponent, RebeccaadventuretravelComponent, GettravelgalapagosComponent]
})
export class CustomHeaderComponent implements OnInit {
  @Output() public headerHeight: EventEmitter<any> = new EventEmitter();
  @Output() public headerHeight1: EventEmitter<any> = new EventEmitter();
  @Input() company!: string;
  headerHeightInput: any;
  headerHeightInput1: any;
  constructor() { }

  ngOnInit(): void {
  }

  getHeight(height: any) {
    this.headerHeightInput = height;
  }

  getHeight1(height: any) {
    this.headerHeightInput1 = height;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.headerHeight.emit(this.headerHeightInput);
      this.headerHeight1.emit(this.headerHeightInput1);
    }, 400);
  }

}
